import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Grid, Pagination } from '@mui/material'
import { useSearchParams, useLocation } from "react-router-dom";

import { backend } from '../../statics/system_variables'
import { AnimalCard, SkeletonCard } from './card';
import { Helmet } from 'react-helmet-async';

export default function AnimalContent(props) {

    //The xs, sm, md, lg, and xl props
    const xs = 12
    const sm = 6
    const md = 6
    const lg = 4
    const xl = 4

    const [dogs, setDogs] = useState(['aaa']);
    const [loading, setLoading] = useState(true);
    const [search,] = useSearchParams();
    const [page, setPage] = useState(1)

    const [apiQuery, setApiQuery] = useState('') //query emtpy by default

    const path = useLocation().pathname
    
    // Destructure setDogs from props to use it directly in the dependency array
    const { setDogs: setParentDogs, breed_id } = props;

    //Reload if query changed
    useEffect(() => {
        setLoading(true)
        if (apiQuery !== '') {
            axios.get(apiQuery)
                .then(({ data }) => {
                    setDogs(data)
                    setLoading(false)
                    setParentDogs?.(data) // Using optional chaining to handle cases where setDogs might not be provided
                })
                .catch((error) => {

                })
        }
        // Scroll to top
        window.scrollTo(0, 0)

    }, [apiQuery, setParentDogs])


    //If the page gets incremented
    useEffect(() => {
        setLoading(true)
        var api_link = backend + '/dogs?' + search.toString() + '&page=' + page

        // On state site, the query parameter gets replaced by the location
        if (path.includes('Bundesland')) {

            const state = decodeURI(path.toString()).match(/Bundesland\/[\wäüöß-]*/)[0].replace('Bundesland/', '')
            api_link = api_link.replace(/&state=[\w-]*/, '')
            api_link += '&state=' + state
            api_link = encodeURI(api_link)
        }
        // On breed site, the query parameter gets replaced by the location
        else if (path.includes('Rasse')) {

            api_link = api_link.replace(/&breed_id=[\w-]*/, '')
            api_link += '&breed_id=' + breed_id
            api_link = encodeURI(api_link)

        }

        setApiQuery(api_link)

        
    }, [page, path, search, breed_id])


    //If the filters are applied or the path location gets changed
    useEffect(() => {
        setPage(1)

        //setLoading(true)
        //Gets called, whenever a filter is adjusted, the site gets incremented or the path gets changed
        var api_link = backend + '/dogs?' + search.toString() + '&page=' + page

        // On state site, the query parameter gets replaced by the location
        if (path.includes('Bundesland')) {

            const state = decodeURI(path.toString()).match(/Bundesland\/[\wäüöß-]*/)[0].replace('Bundesland/', '')
            api_link = api_link.replace(/&state=[\w-]*/, '')
            api_link += '&state=' + state
            api_link = encodeURI(api_link)
        }
        // On breed site, the query parameter gets replaced by the location
        else if (path.includes('Rasse')) {

            api_link = api_link.replace(/&breed_id=[\w-]*/, '')
            api_link += '&breed_id=' + breed_id
            api_link = encodeURI(api_link)

        }

        setApiQuery(api_link)

    }, [search, path, breed_id, page])





    if (loading) {

        return (

            <Grid container spacing={2}>


                {[...Array(12)].map((currel, index) => (
                    <React.Fragment key={index.toString()}>
                        <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                            <SkeletonCard index={index} />
                        </Grid>
                    </React.Fragment>


                ))}

            </Grid>

        )
    }

    return <Grid container spacing={2}>

        {dogs[2] > 0 ? <></> : <Helmet><meta name="robots" content="noindex" /></Helmet>}


        {dogs[0].map((dog) => (
            <React.Fragment key={dog.dog_link}>
                <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                    <AnimalCard dog={dog} />
                </Grid>
            </React.Fragment>
        ))}





        <Grid item xs={12}>
            <Pagination count={dogs[1]} page={page} variant="outlined" shape="rounded" boundaryCount={2} sx={{ justifyContent: 'center', display: 'flex' }} onChange={(event, page) => setPage(page)} />
        </Grid>
    </Grid>

}
